<ul class="grid row">
    <li (click)="backToStep(1)" class="col">
        <div class="img" [style.backgroundImage]="currentStyle ? 'url(assets/img/'+ currentStyle.img +')' : 'none'">
            <div *ngIf="!currentStyle" class="no-pref-image">
                <span class="text">
                    <svg class="icon-action-replace" aria-hidden="true">
                        <use xlink:href="assets/img/icons.svg#icon-action-replace"></use>
                    </svg>
                    {{ 'need_mapping.no_choice.img_text' | translate }}
                </span>
            </div>

            <span class="state">
                <span class="text">
                    <svg class="icon-action-replace" aria-hidden="true">
                        <use xlink:href="assets/img/icons.svg#icon-action-replace"></use>
                    </svg>
                    {{ 'need_mapping.no_choice.img_text' | translate }}
                </span>
            </span>
        </div>
        <div class="title">
            <h3 class="tt-3" *ngIf="currentStyle">{{currentStyle.title | translate}}</h3>
            <span class="icon-action-replace" aria-hidden="true">
                <svg>
                    <use xlink:href="assets/img/icons.svg#icon-action-replace"></use>
                </svg>
            </span>
        </div>
        <p class="subtitle">{{ 'need_mapping.steps.title_1_short' | translate }}</p>
    </li>

    <li (click)="backToStep(2)" class="col">
        <div class="img" [style.backgroundImage]="currentModel ? 'url(assets/img/'+ currentModel.img +')' : 'none'">

            <div *ngIf="!currentModel" class="no-pref-image">
                <span class="text">
                    <svg class="icon-action-replace" aria-hidden="true">
                        <use xlink:href="assets/img/icons.svg#icon-action-replace"></use>
                    </svg>
                    {{ 'need_mapping.no_choice.img_text' | translate }}
                </span>
            </div>

            <span class="state">
                <span class="text">
                    <svg class="icon-action-replace" aria-hidden="true">
                        <use xlink:href="assets/img/icons.svg#icon-action-replace"></use>
                    </svg>
                    {{ 'need_mapping.no_choice.img_text' | translate }}
                </span>
            </span>
        </div>
        <div class="title">
            <h3 class="tt-3" *ngIf="currentModel">{{currentModel.title}}</h3>
            <span class="icon-action-replace" aria-hidden="true">
                <svg>
                    <use xlink:href="assets/img/icons.svg#icon-action-replace"></use>
                </svg>
            </span>
        </div>
        <p class="subtitle">{{ 'need_mapping.steps.title_2_short' | translate }}</p>
    </li>

    <li (click)="backToStep(3)" class="col">
        <div class="img">
            <img *ngIf="currentLayout" [src]="'assets/img/'+currentLayout.img" [alt]="currentLayout.titleRef | translate">

            <div *ngIf="!currentLayout" class="no-pref-image">
                <span class="text">
                    <svg class="icon-action-replace" aria-hidden="true">
                        <use xlink:href="assets/img/icons.svg#icon-action-replace"></use>
                    </svg>
                    {{ 'need_mapping.no_choice.img_text' | translate }}
                </span>
            </div>

            <span class="state">
                <span class="text">
                    <svg class="icon-action-replace" aria-hidden="true">
                        <use xlink:href="assets/img/icons.svg#icon-action-replace"></use>
                    </svg>
                    {{ 'need_mapping.no_choice.img_text' | translate }}
                </span>
            </span>
        </div>
        <div class="title">
            <h3 class="tt-3" *ngIf="currentLayout">{{currentLayout.titleRef | translate}}</h3>
            <span class="icon-action-replace" aria-hidden="true">
                <svg>
                    <use xlink:href="assets/img/icons.svg#icon-action-replace"></use>
                </svg>
            </span>
        </div>
        <p class="subtitle">{{ 'need_mapping.steps.title_3_short' | translate }}</p>
    </li>
    
    <li (click)="backToStep(4)" class="col">
        <div class="img">
            <img *ngIf="currentFurniture" [src]="'assets/img/'+currentFurniture.img" [alt]="currentFurniture.titleRef | translate">

            <div *ngIf="!currentFurniture" class="no-pref-image">
                <span class="text">
                    <svg class="icon-action-replace" aria-hidden="true">
                        <use xlink:href="assets/img/icons.svg#icon-action-replace"></use>
                    </svg>
                    {{ 'need_mapping.no_choice.img_text' | translate }}
                </span>
            </div>

            <span class="state">
                <span class="text">
                    <svg class="icon-action-replace" aria-hidden="true">
                        <use xlink:href="assets/img/icons.svg#icon-action-replace"></use>
                    </svg>
                    {{ 'need_mapping.no_choice.img_text' | translate }}
                </span>
            </span>
        </div>
        <div class="title">
            <h3 class="tt-3" *ngIf="currentFurniture">{{currentFurniture.titleRef | translate}}</h3>
            <span class="icon-action-replace" aria-hidden="true">
                <svg>
                    <use xlink:href="assets/img/icons.svg#icon-action-replace"></use>
                </svg>
            </span>
        </div>
        <p class="subtitle">{{ 'need_mapping.steps.title_4_short' | translate }}</p>
    </li>

    <li (click)="backToStep(5)" class="col">
        <div class="img">
            <img *ngIf="currentOvenConfiguration" [src]="'assets/img/'+currentOvenConfiguration.img" [alt]="currentOvenConfiguration.titleRef | translate">

            <div *ngIf="!currentOvenConfiguration" class="no-pref-image">
                <span class="text">
                    <svg class="icon-action-replace" aria-hidden="true">
                        <use xlink:href="assets/img/icons.svg#icon-action-replace"></use>
                    </svg>
                    {{ 'need_mapping.no_choice.img_text' | translate }}
                </span>
            </div>

            <span class="state">
                <span class="text">
                    <svg class="icon-action-replace" aria-hidden="true">
                        <use xlink:href="assets/img/icons.svg#icon-action-replace"></use>
                    </svg>
                    {{ 'need_mapping.no_choice.img_text' | translate }}
                </span>
            </span>
        </div>
        <div class="title">
            <h3 class="tt-3" *ngIf="currentOvenConfiguration">{{currentOvenConfiguration.titleRef | translate}}</h3>
            <span class="icon-action-replace" aria-hidden="true">
                <svg>
                    <use xlink:href="assets/img/icons.svg#icon-action-replace"></use>
                </svg>
            </span>
        </div>
        <p class="subtitle">{{ 'need_mapping.steps.title_5_short' | translate }}</p>
    </li>
</ul>

<p class="text-center"><ng-hbm-bdi-btn class="primary" (click)="start()" [routerLink]="['/kitchen/configuration']" [label]="'need_mapping.cta' | translate"></ng-hbm-bdi-btn></p>
